import { faEdit, faSave, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import ModalComponent from "../../../Components/Modais";

import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import React from "react";
import {
    DeletarHorariosDisponiveisController,
    ListarHorariosDisponiveisController,
} from "../../../Controllers/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelController";
import { IListarCompromissoDisponivelHorario } from "../../../Interfaces/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelInterfaces";
import CadastraEEditaHorarios from "./CadastrarEEditarHorarios";

export default function HorariosDisponiveis() {
    const { PageFilter, setPage } = usePaginationFilter({ page: 1 });
    const [show, SetShow] = useState(false);
    const [Modal, SetModal] = useState<IComponentModal>();

    const {
        execute: listarHorariosExec,
        value: listarHorariosDisponiveis,
        loading: listarHorariosDisponiveisLoading,
    } = useAsyncEffect(
        () => ListarHorariosDisponiveisController(),
        [PageFilter]
    );

    function rowTipoDocumentoEtapa(
        cell: string,
        row: IListarCompromissoDisponivelHorario
    ) {
        return (
            <div className="rowCapysTCA d-flex justify-content-center align-items-center mr-5">
                <div>
                    <label className="mb-1">{row.DS_HORARIO}</label>
                </div>
            </div>
        );
    }

    //Tabela
    const columns: Array<
        ColumnDescription<IListarCompromissoDisponivelHorario>
    > = [
        {
            dataField: "DS_HORARIO",
            text: "Horário",
            formatter: rowTipoDocumentoEtapa,
            sort: true,
        },
        {
            dataField: "button",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="Button-Tools">
                    <button
                        className="btn btn-outline-primary font-weight-bold mr-2"
                        type="button"
                        onClick={() => {
                            SetShow(true);
                            SetModal({
                                headerComponent: "Editar Horário",
                                Component: () => (
                                    <CadastraEEditaHorarios
                                        updateList={listarHorariosExec}
                                        setShow={SetShow}
                                        row={row}
                                    />
                                ),
                                size: "lg",
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                    </button>
                    <button
                        className="btn btn-outline-danger font-weight-bold mr-2"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja apagar este Horário?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DeletarHorariosDisponiveisController(
                                        row.ID_COMPROMISSO_VISTORIA_DISPONIVEL_HORARIO
                                    ).then(() => {
                                        listarHorariosExec();
                                    });
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon size="lg" icon={faTrash} /> Excluir
                    </button>
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="card">
                <div className="card-header d-flex justify-content-between">
                    <h2 className="mb-0">Horários Disponíveis</h2>
                    <button
                        className="btn btn-sm btn-shadow btn-success d-flex align-items-center flex-nowrap w-10 mb-4"
                        type="button"
                        onClick={() => {
                            SetShow(true);
                            SetModal({
                                headerComponent: "Cadastro de Horário",
                                Component: () => (
                                    <CadastraEEditaHorarios
                                        updateList={listarHorariosExec}
                                        setShow={SetShow}
                                    />
                                ),
                                size: "lg",
                            });
                        }}
                    >
                        <span className="d-flex align-items-center justify-content-center g-2">
                            Cadastrar um Horário{" "}
                            <FontAwesomeIcon size="sm" icon={faSave} />
                        </span>
                    </button>
                </div>
                <div className="card-body">
                    <div className="col-12 mt-5">
                        <OrSpinner
                            loading={listarHorariosDisponiveisLoading}
                            spinner="capys"
                        >
                            <Table
                                keyField="ID_COMPROMISSO_VISTORIA_DISPONIVEL_HORARIO"
                                columns={columns}
                                data={listarHorariosDisponiveis ?? []}
                                sizePerPage={10}
                                loading={listarHorariosDisponiveisLoading}
                                noDataIndication={
                                    <div className="text-center text-muted">
                                        Nenhum Horário
                                    </div>
                                }
                                onTableChange={(type, newState) => {
                                    setPage(newState.page);
                                }}
                                defaultSorted={[
                                    {
                                        dataField: "DS_HORARIO",
                                        order: "asc",
                                    },
                                ]}
                                wrapperClasses="wrapperTable mw-100 x-scroll"
                                classes="tableClasses"
                                bordered={false}
                                center
                                defaultStyle={{
                                    align: "center",
                                    classes: "p-2",
                                }}
                            />
                        </OrSpinner>
                    </div>
                </div>

                <ModalComponent
                    show={show}
                    setShow={SetShow}
                    ModalComponent={Modal}
                />
            </div>
        </>
    );
}
